import { ForwardRef } from 'react-is';

/**
 * Type that represents a component that has been wrapped by redux.
 */

/**
 * Checks if a component is a wrapped component.
 * @param Component The component to check
 * @returns Whether the component is a wrapped component or not
 */
export function isWrappedComponent(Component) {
  return (Component === null || Component === void 0 ? void 0 : Component.WrappedComponent) !== undefined;
}

/**
 * Checks if a component is a class component.
 * @param Component The component to check
 * @returns Whether the component is a class component or not
 */
export function isClassComponent(Component) {
  if (isWrappedComponent(Component) && isClassComponent(Component.WrappedComponent)) {
    return true;
  }
  return Component.prototype != null && Component.prototype.isReactComponent != null;
}

/**
 * Checks if a component is a forward ref component.
 * @param Component The component to check
 * @returns Whether the component is a forward ref component or not
 */
export function isForwardRefComponentType(Component) {
  return !isWrappedComponent(Component) &&
  // Do a check right on the `$$typeof` the component. The `isForwardRef` function in `react-is` checks against a `Component` instance, whereas
  // we want to check against a `ComponentType` which is the class/function that defines a component.
  '$$typeof' in Component && Component.$$typeof === ForwardRef;
}

/**
 * Checks if a component can have a ref. Helps silence react dev errors
 * if a ref is passed to a functional component without forwardRef.
 * @param Component The component to check if it can take a ref
 * @returns Whether the component can have a ref or not
 */
export function canHaveRef(Component) {
  return isClassComponent(Component) || isForwardRefComponentType(Component);
}
//# sourceMappingURL=ComponentUtils.js.map